<template>
  <div class="bg-white font-size-14 text-26">
    <div class="yxtbiz-enroll-manage__header-title font-bolder">{{$t('pc_biz_enroll_lbl_baseinfo' /* 基本信息 */)}}</div>
    <div class="yxtbiz-enroll-manage__header-content layout-flex p24 lh22">
      <div class="flex-1 mr24" >
        <yxt-row>
          <yxt-col :span='12' class="pr24 layout-flex">
            <span class="text-8c  flex-shrink-0">{{$t('pc_biz_enroll_lbl_name' /* 报名名称 */)}}{{$t('pc_biz_enroll_lbl_colon' /* ： */)}}</span>
            <yxt-tooltip class="item"
                         effect="dark"
                         :open-filter="true"
                         :content="headerData.enrollName"
                         placement="top">
              <span class="nowrap ellipsis">{{headerData.enrollName}}</span>
            </yxt-tooltip>
          </yxt-col>
          <yxt-col :span='12' class="pr24">
            <span class="text-8c">{{$t('pc_biz_enroll_lbl_enrolled' /* 已报名 */)}}{{$t('pc_biz_enroll_lbl_colon' /* ： */)}}</span>
            <span>{{ headerData.registeredNum }}</span>
          </yxt-col>
        </yxt-row>
        <yxt-row class="mt12">
          <yxt-col :span='12' class="pr24">
            <span class="text-8c">{{$t('pc_biz_enroll_lbl_signupStatus' /* 报名状态 */)}}{{$t('pc_biz_enroll_lbl_colon' /* ： */)}}</span>
            <yxt-tag :type="statusConfig[headerData.status].type" size="mini">{{ statusConfig[headerData.status].text }}</yxt-tag>
          </yxt-col>
          <yxt-col :span='12' class="pr24">
            <span class="text-8c">{{$t('pc_biz_enroll_lbl_toaudit' /* 待审核 */)}}{{$t('pc_biz_enroll_lbl_colon' /* ： */)}}</span>
            <span>{{ headerData.waitCheckNum }}</span>
          </yxt-col>
        </yxt-row>
        <yxt-row class="mt12">
          <yxt-col :span='12' class="pr24 layout-flex over-hidden">
            <span class="text-8c flex-shrink-0">{{$t('pc_biz_enroll_lbl_enrolltime' /* 报名时间 */)}}{{$t('pc_biz_enroll_lbl_colon' /* ： */)}}</span>
            <yxt-tooltip class="item"
                         effect="dark"
                         :open-filter="true"
                         :content="enrollTime"
                         placement="top">
              <span class="nowrap ellipsis">{{ enrollTime }}</span>
            </yxt-tooltip>
          </yxt-col>
          <yxt-col :span='12' class="pr24 layout-flex over-hidden layout-align-center">
            <span class="text-8c flex-shrink-0">{{$t('pc_biz_enroll_lbl_signupUrl' /* 报名链接 */)}}{{$t('pc_biz_enroll_lbl_colon' /* ： */)}}</span>
            <yxt-tooltip class="item"
                         effect="dark"
                         :open-filter="true"
                         :content="qrCodeUrl"
                         placement="top">
              <span class="ellipsis mr8">{{qrCodeUrl}}</span>
            </yxt-tooltip>
            <yxt-svg
              :icon-class="'o2o-enroll-copy'"
              width="16px"
              height="16px"
              class="hand flex-shrink-0"
              :remote-url="`${$staticBaseUrl}ufd/55a3e0/o2o/pc/svg`"
              @click.native="copyUrl"
            ></yxt-svg>
          </yxt-col>
        </yxt-row>
      </div>
      <div class="pr hand">
        <div v-if="qrCodeUrl" @click="qrCodeVisible = true">
          <yxtbiz-qrcode
            :size='96'
            :url="qrCodeUrl"
            :hide-link='true'
            :hide-download="true"
            :padding="0"></yxtbiz-qrcode>
          <div class="text-center mt8 font-size-12 lh20">{{$t('pc_biz_enroll_lbl_projectqrcode' /* 报名二维码 */)}}</div>
        </div>
      </div>
    </div>
    <!-- 项目二维码 -->
    <yxt-dialog
      :append-to-body="true"
      :visible.sync="qrCodeVisible"
      :cutline="false"
      :width="$isEnglish ? '480px' : '410px'">
      <div class="text-center">
        <div class="mt8 mb12">
          <yxtbiz-qrcode :url="qrCodeUrl"
                         :size="218"
                         :padding="34"
                         :hide-link="false"
                         :hide-download="false"
                         :name="headerData.enrollName"
                         is-project
                         :project-tip="projectTip"
          ></yxtbiz-qrcode>
        </div>
      </div>
    </yxt-dialog>
  </div>
</template>

<script>
import { Tooltip, Tag, Row, Col, Dialog } from 'yxt-pc';
import YxtBizQrcode from 'yxt-biz-pc/packages/qrcode';
export default {
  name: 'EnrollManageAuditHeader',
  props: {
    qrCodeUrl: String,
    qrCodeText: String,
    headerData: {
      type: Object,
      default: () => {
        return {
          alternateNum: null, // 替补学员人数
          endTime: null, // 报名结束时间
          formalNum: null, // 正式学员人数
          registeredNum: null, // 已报名人数
          startTime: null, // 报名开始时间
          status: 0, // 状态,0：未发布（已设置），1：发布中（人员分解），2：已发布（报名中），3：已暂停，4：已结束
          waitCheckNum: null, // 待审核人数
          enrollName: '' // 报名名称
        };
      }
    },
    showOverTime: {
      type: Boolean,
      default: false
    }
  },
  components: {
    YxtTooltip: Tooltip,
    YxtTag: Tag,
    YxtRow: Row,
    YxtCol: Col,
    YxtDialog: Dialog,
    YxtBizQrcode
  },
  computed: {
    projectTip() {
      return this.qrCodeText || this.$t('pc_biz_enroll_tip_project_qrcode' /* 本项目专属二维码，可用于扫码学习和报名 */);
    },
    enrollTime() {
      if (this.headerData.startTime && this.headerData.endTime) {
        return this.headerData.startTime + ' ' + this.$t('pc_biz_enroll_to' /* 至 */) + ' ' + this.headerData.endTime;
      } else {
        return '--';
      }
    }
  },
  data() {
    const statusConfig = {
      0: {
        text: this.$t('pc_biz_enroll_hasSet' /* 已设置 */),
        type: ''
      },
      // 1: {
      //   text: i18n.t('pc_biz_enroll_lbl_publishing' /* 发布中 */),
      //   type: ''
      // },
      2: {
        text: this.$t('pc_biz_enroll_lbl_hasOpen' /* 已开启 */),
        type: 'success'
      },
      3: {
        text: this.$t('pc_biz_enroll_lbl_projectstop' /* 已暂停 */),
        type: 'info'
      },
      4: {
        text: this.$t('pc_biz_enroll_lbl_projectover' /* 已结束 */),
        type: 'info'
      },
      null: {
        text: '',
        type: ''
      }
    };
    return {
      statusConfig,
      qrCodeVisible: false
    };
  },
  methods: {
    copyUrl() {
      let input = document.createElement('input');
      input.value = this.qrCodeUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand('Copy'); // 执行浏览器复制命令
      this.$message.success(this.$t('pc_biz_enroll_msg_arrangecopied' /* 复制成功 */));
      document.body.removeChild(input);
    }
  }
};
</script>
